var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSoundOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  color: "currentColor",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.364 4.223a1 1 0 0 1 1.414 0A10.97 10.97 0 0 1 23 12c0 3.037-1.232 5.788-3.222 7.778a1 1 0 1 1-1.414-1.414A8.97 8.97 0 0 0 21 12a8.97 8.97 0 0 0-2.636-6.364 1 1 0 0 1 0-1.414"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.596 7.404a1 1 0 1 0-1.414 1.414A4.48 4.48 0 0 1 16.5 12a4.48 4.48 0 0 1-1.318 3.182 1 1 0 1 0 1.414 1.415A6.48 6.48 0 0 0 18.5 12a6.48 6.48 0 0 0-1.904-4.596M13 4.5c0-1.236-1.411-1.942-2.4-1.2L5.933 6.8a1 1 0 0 1-.6.2H4a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h1.333a1 1 0 0 1 .6.2l4.667 3.5c.989.742 2.4.036 2.4-1.2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.778 4.223a1 1 0 0 0-1.414 1.414A8.97 8.97 0 0 1 21 12a8.97 8.97 0 0 1-2.636 6.364 1 1 0 0 0 1.414 1.414A10.97 10.97 0 0 0 23 12.001c0-3.037-1.232-5.789-3.222-7.778"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.596 7.404a1 1 0 1 0-1.414 1.414 4.48 4.48 0 0 1 1.318 3.183 4.48 4.48 0 0 1-1.318 3.181 1 1 0 0 0 1.414 1.415A6.48 6.48 0 0 0 18.5 12a6.48 6.48 0 0 0-1.904-4.596"
})));
export default SvgSoundOn;